import {
  Interceptor,
  StreamRequest,
  StreamResponse,
  UnaryRequest,
} from '@bufbuild/connect';

type ErrorReporter = (
  error: unknown,
  request: UnaryRequest | StreamRequest,
  response?: StreamResponse,
) => void;

export const createErrorReportingInterceptor =
  (report: ErrorReporter): Interceptor =>
  (next) =>
  async (request) => {
    try {
      const response = await next(request);

      if (!response.stream) {
        return response;
      }

      return {
        ...response,
        message: (async function* () {
          try {
            yield* response.message;
          } catch (error) {
            report(error, request, response);
            throw error;
          }
        })(),
      };
    } catch (error) {
      report(error, request);
      throw error;
    }
  };
